const INITIAL_STATE = {
  menu: null,
};

export default function menu(state = INITIAL_STATE, action) {
  const menu = updateMenu(state.menu);
  switch (action.type) {
    case "SET_CATEGORIES":
      return {
        ...state,
        menu: action.categories,
      };

    case "ADD_PRODUCT_SYNC":
      return {
        ...state,
        menu: menu.products.add(action.product),
      };

    case "SAVE_PRODUCT_SYNC":
      return {
        ...state,
        menu: menu.products.update(action.productData),
      };

    case "REMOVE_PRODUCT_SYNC":
      return {
        ...state,
        menu: menu.products.remove(action.productId),
      };

    case "CLONE_PRODUCT_SYNC":
      return {
        ...state,
        menu: menu.products.add(action.product),
      };

    case "CHANGE_VISIBILITY_PRODUCT_SYNC":
      return {
        ...state,
        menu: menu.products.setVisibility(action.id, action.visibility),
      };
    default:
      return state;
  }
}

function updateMenu(menu) {
  function addProduct(product) {
    return menu.map((category) => {
      if (category._id === product.categoryId) {
        category.itens.push(product);
      }

      return category;
    });
  }

  function updateProduct(productData) {
    return menu.map((category) => {
      const itens = category.itens.map((product) => {
        if (product._id === productData._id) {
          return { ...product, ...productData };
        }
        return product;
      });
      return { ...category, itens };
    });
  }

  function removeProduct(productIdToRemove) {
    return menu.map((category) => {
      const filteredItens = category.itens.filter(
        (product) => product._id !== productIdToRemove
      );
      return { ...category, itens: filteredItens };
    });
  }

  function setProductVisibility(productId, visibility) {
    return menu.map((category) => {
      const filteredItens = category.itens.map((product) => {
        if (product._id === productId) {
          product.is_active = visibility;
        }
        return product;
      });
      return { ...category, itens: filteredItens };
    });
  }

  return {
    products: {
      add: addProduct,
      remove: removeProduct,
      setVisibility: setProductVisibility,
      update: updateProduct,
    },
  };
}
